module.exports = __webpack_public_path__ + "static/media/component6.3ac93712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/component6.png
// module id = 2410
// module chunks = 0